module.exports = __webpack_public_path__ + "img/Hauge_Frimerke.a21862a4.jpg";